// Module
var code = `<div class="modal fade" id="complaintsTableModal" tabindex="-1" role="dialog" data-bind="showModal: show">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-bind="click: clear">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" data-bind="label: 'cc_P_COMPLAINTS_FOR_ORDER_TITLE'"></h4>
            </div>
            <div class="modal-body">
                <table id="complaintsList" class="table table-hover table-striped table-sortable">
                    <thead>
                        <tr>
                            <th data-bind="label: 'cc_P_COMPLAINT_ID'" style="white-space: nowrap;"></th>
                            <th data-bind="label: 'cc_P_COMPLAINT_TYPE'" style="white-space: nowrap;"></th>
                            <th data-bind="label: 'cc_P_DELIVERY_ORDER'" style="white-space: nowrap;"></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: complaintsForOrder">
                        <tr>
                            <td style="white-space: nowrap;" data-bind="text: complaint_id">
                                <a tabindex="-1" target="_blank" data-bind="text: complaint_id, attr: { href: 'complaint_management/complaints_list/' + complaint_id }"></a>
                            </td>
                            <td style="white-space: nowrap;" data-bind="lookupDescription: { lookup: \$component.lookupDescription, name: 'C_COMPLAINT_TYPE', value: complaint_type }"></td>
                            <td style="white-space: nowrap;" data-bind="text: original_delivery_order"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal" data-bind="click: continue, label: 'cc_P_CONTINUE_COMPL_CREATE'"></button>
                <button type="button" class="btn btn-default" data-dismiss="modal" data-bind="click: clear, label: 'cc_Close'"></button>
            </div>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;